export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export const REGISTER_USER = "REGISTER_USER";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";
